module.exports = __webpack_public_path__ + "img/photolight_thumbnail.3a24876a.jpg";